import React from 'react';
import '../../css/StaticPages.css';

const PrivacyPolicy = () => {
  React.useEffect(() => {
    document.documentElement.classList.add('allow-page-scroll');
    document.body.classList.add('allow-page-scroll');
    return () => {
      document.documentElement.classList.remove('allow-page-scroll');
      document.body.classList.remove('allow-page-scroll');
    };
  }, []);

  return (
    <div style={{ maxWidth: '900px', margin: '40px auto', padding: '0 16px', lineHeight: 1.75 }}>
      <h1 style={{ marginBottom: 8 }}>Privacy Policy</h1>
      <p style={{ color: '#666', marginTop: 0 }}>Last updated: {new Date().toISOString().split('T')[0]}</p>

      <p>
        This Privacy Policy explains how we collect, use, disclose, and safeguard information when you use our
        knowledge note management and sharing service ("Service"). By using the Service, you consent to the practices
        described in this Privacy Policy.
      </p>

      <h2>1. Information We Collect</h2>
      <ul>
        <li>
          Account Information: username, email address, password (hashed), and optional profile details you provide.
        </li>
        <li>
          User Content: notes, documents, tags, comments, and related metadata you create or upload to the Service.
        </li>
        <li>
          Usage Data: interactions with the Service, device and browser information, IP address, locale, and cookies.
        </li>
        <li>
          Payment Data: handled by our payment processor. We do not store full card numbers; see Section 6.
        </li>
      </ul>

      <h2>2. How We Use Information</h2>
      <ul>
        <li>Provide, maintain, and improve the Service and user experience.</li>
        <li>Authenticate users and secure accounts.</li>
        <li>Sync and back up your content where applicable.</li>
        <li>Process payments and manage subscriptions.</li>
        <li>Communicate service updates, security alerts, and support messages.</li>
        <li>Comply with legal obligations and enforce our Terms.</li>
      </ul>

      <h2>3. Sharing of Information</h2>
      <ul>
        <li>
          We share information with service providers (e.g., hosting, analytics, email, payments) who process data on
          our behalf under contractual obligations.
        </li>
        <li>
          If you choose to share notes or workspaces, information is shared with recipients according to your settings.
        </li>
        <li>
          We may disclose information if required by law, regulation, legal process, or to protect rights and safety.
        </li>
      </ul>

      <h2>4. Data Retention</h2>
      <p>
        We retain information for as long as necessary to provide the Service and fulfill the purposes outlined in this
        Privacy Policy, unless a longer retention period is required or permitted by law. Backups may persist for a
        limited period after deletion.
      </p>

      <h2>5. Your Choices</h2>
      <ul>
        <li>Access, update, or delete your account information within the Service.</li>
        <li>Control sharing settings for your notes and workspaces.</li>
        <li>Manage cookies via browser settings; disabling cookies may affect functionality.</li>
        <li>Opt out of non-essential communications by using unsubscribe links within emails.</li>
      </ul>

      <h2>6. Payments</h2>
      <p>
        Payments are processed by Stripe, Inc. and its affiliates ("Stripe"). Stripe's terms and privacy policy apply
        to payment processing; see <a href="https://stripe.com/legal" target="_blank" rel="noopener noreferrer">https://stripe.com/legal</a> and
        <a href="https://stripe.com/privacy" target="_blank" rel="noopener noreferrer">https://stripe.com/privacy</a>. We do not store full payment card details on our servers.
      </p>

      <h2>7. Security</h2>
      <p>
        We implement reasonable administrative, technical, and physical safeguards designed to protect information
        against unauthorized access, loss, misuse, or alteration. However, no method of transmission or storage is
        completely secure, and we cannot guarantee absolute security.
      </p>

      <h2>8. International Transfers</h2>
      <p>
        Your information may be processed and stored in countries other than your country of residence. We take steps
        to ensure appropriate safeguards in accordance with applicable laws.
      </p>

      <h2>9. Children's Privacy</h2>
      <p>
        The Service is not directed to children under 16. We do not knowingly collect personal information from
        children under 16 without appropriate consent.
      </p>

      <h2>10. Changes to this Policy</h2>
      <p>
        We may update this Privacy Policy from time to time. Material changes will be notified within the Service or by
        other reasonable means. Your continued use indicates acceptance of the updated policy.
      </p>

      <h2>11. Contact Us</h2>
      <p>
        If you have questions about this Privacy Policy, please contact us via the support channels provided in the
        Service.
      </p>
    </div>
  );
};

export default PrivacyPolicy;


